import React from 'react';
import PropTypes from 'prop-types';
import { get, map } from 'lodash';
import Button from '../elements-buttons/Button';
import TextButton from '../elements-buttons/text-button';
import { FormattedMessage } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

export class CancelBookingOptions extends React.Component {
  constructor (props) {
    super(props);

    this.handleReceiveCreditClick = this.handleReceiveCreditClick.bind(this);
    this.handleCancelBkgClick = this.handleCancelBkgClick.bind(this);
  }

  componentDidMount () {
    const { contracts, cancelContractObj } = this.props;
    const incentiveEligible = get(cancelContractObj, 'incentive_credit_eligible', false);

    const cancelProperties = {
      eligible_for_credit_bonus: incentiveEligible,
      credit_bonus_pct_shown: incentiveEligible ? 20 : 0
    }

    analyticsIntegrations.cancelOptionsViewed(cancelProperties, contracts);
  }

  handleReceiveCreditClick () {
    this.props.selectCancelAction(true);
  }

  handleCancelBkgClick () {
    this.props.selectCancelAction(false);
  }

  render () {
    const {  cancelContractObj = {} } = this.props;
    const incentiveEligible = get(cancelContractObj, 'incentive_credit_eligible', false);
    const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();

    const bulletList = [
      { icon: 'refund',
        text: <FormattedMessage id='inbox.cancel_booking_options.receive_refund' defaultMessage='Receive your refund in Peerspace Credits' />
      },
      { icon: 'bolt',
        text: <FormattedMessage id='inbox.cancel_booking_options.instantly_available' defaultMessage='Instantly available in your Peerspace account' />
      },
      { icon: 'space',
        text: <FormattedMessage id='inbox.cancel_booking_options.use_credit' defaultMessage='Easily use credit at checkout for any future booking' />
      }
    ];

    return (
      <div className="CancelBookingOptions page credit-option">
        <div className="container-fluid text-center">

          <div className="col-xs-12 margin-xl-bottom margin-md-top">
            <div className="h1 cancel-header">
              <FormattedMessage
                id='inbox.cancel_booking_options.receive_credit'
                defaultMessage='Receive {incentiveEligible}'
                values={{
                  incentiveEligible: incentiveEligible
                    ? <FormattedMessage id='inbox.cancel_booking_options.bonus_credit' defaultMessage='a 20% bonus credit' />
                    : <FormattedMessage id='inbox.cancel_booking_options.refund_credit' defaultMessage='your refund in Peerspace Credit' />
                }}
              />
            </div>
            <div className="text-gray-dark" data-testing-id="cancel-options-info">
              { incentiveEligible
                ? <FormattedMessage id='inbox.cancel_booking_options.receive_your_refund' defaultMessage='Choose to receive your refund in Peerspace Credits and we’ll give you a 20% bonus. Peerspace Credits can be used on any future booking and never expire.' />
                : <FormattedMessage id='inbox.cancel_booking_options.you_eligbile' defaultMessage='You’re eligbile to receive your refund in Peerspace Credits. You can easily use credits for any future booking with any host. Credits never expire.' />
              }
              <a href={`https://support.peerspace.com/hc/${zendeskLocale}/articles/360041426311-How-do-I-redeem-Peerspace-credit-`} target="_blank" rel="noopener noreferrer"> <FormattedMessage id='inbox.cancel_booking_options.learn_more' defaultMessage='Learn More' /></a>
            </div>
          </div>

          <img
            className={incentiveEligible ? 'hidden-xs' : ''}
            width={incentiveEligible ? 550 : 260}
            src={`https://assets.peerspace.com/credit-refund${incentiveEligible ? '-incentive' : ''}.jpg`}
            alt="ps-credit"
          />

          { incentiveEligible &&

            <img
              className="visible-xs block-xs-center"
              width={260}
              src="https://assets.peerspace.com/credit-refund-incentive-mobile.jpg"
              alt="ps-credit"
              data-testing-id="credit-refund-incentive-mobile-img"
            />
          }

          <hr />

          <div className="flex space-between middle column-xs">
            { map(bulletList, (bullet, i) => {
              return (
                <div className="margin-lg-bottom margin-lg-top" key={`bullet-${i}`} style={{ maxWidth: 220 }} data-testing-id="cancel-options-bullet">
                  <img src={`https://assets.peerspace.com/${bullet.icon}-green.svg?v=rb`} alt={`${bullet.icon}-icon`}/>
                  <div className="margin-md-top">{bullet.text}</div>
                </div>
              )
            })}
          </div>

          <hr />

          <div className="margin-lg-bottom" style={{ paddingTop: 16 }}>
            <Button
              className="btn btn-primary credit-cta"
              onClick={this.handleReceiveCreditClick}
              type="button"
            >
              <FormattedMessage id='inbox.cancel_booking_options.cancel_credit' defaultMessage='Cancel for Peerspace Credit' /> {incentiveEligible ? '+ 20% ' : ''}
            </Button>
          </div>

          <TextButton
            classNames="no-gutter margin-md-bottom"
            buttonText={ <FormattedMessage id='inbox.cancel_booking_options.no_thanks' defaultMessage='No thanks' /> }
            onClick={this.handleCancelBkgClick}
          />

        </div>
      </div>
    );
  }
}

CancelBookingOptions.propTypes = {
  booking: PropTypes.object
};

CancelBookingOptions.contextTypes = {
  router: PropTypes.object
};
